"use client";

import { c as _c } from "react/compiler-runtime";
import { useEvent } from "@/app/(context)/analytics-context";
import { getEventContext } from "../_lib/eventContext";
export function useInhomzTrack() {
  const $ = _c(2);
  const {
    pushEvent
  } = useEvent();
  let t0;
  if ($[0] !== pushEvent) {
    t0 = (t1, t2) => {
      const {
        event,
        action
      } = t1;
      const properties = t2 === undefined ? {} : t2;
      pushEvent?.(event, {
        ...getEventContext(),
        event_action: action,
        ...properties
      }, {
        includeUserId: false
      });
    };
    $[0] = pushEvent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}